import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import axios from 'axios'

import Cookies from 'js-cookie'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/admin',
    name: 'admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/AdminView.vue')
    }
  },
  {
    path: '/about',
    name: 'about',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const cookie = Cookies.get("session")
  if (!cookie && to.name !== "login") {
    next({ name: "login", replace: true })
    return;
  }
  if (to.name === "admin" && Cookies.get("is_admin") !== "true") {
    next({ name: "home", replace: true })
    return;
  }
  next()
})

router.afterEach((to) => {
  const user = Cookies.get("user")
  if (user && to.name === "home") {
    axios.post("/api/track", { type: "page_view", user }).catch(() => {})
  }
})

export default router
